import useSWR from "swr";

import { api } from "../services";

const PRESENT_URL = "/web-user/dashboard/present";
const ABSENT_URL = "/web-user/dashboard/absent";
const LATE_URL = "/web-user/dashboard/late";
const ATTENDANCE_URL = "/web-user/dashboard/attendance";

export const useDashboard = () => {
  const { data, isLoading, mutate } = useSWR("/web-user/dashboard", api.get);
  const stats = data?.stats || {};

  const getTotalPresent = async (query = {}) => {
    const qs = new URLSearchParams(query).toString();
    const present = await api.get(`${PRESENT_URL}?${qs}`);
    return present;
  };

  const getTotalAbsent = async (query = {}) => {
    const qs = new URLSearchParams(query).toString();
    const absent = await api.get(`${ABSENT_URL}?${qs}`);
    return absent;
  };

  const getTotalLate = async (query = {}) => {
    const qs = new URLSearchParams(query).toString();
    const late = await api.get(`${LATE_URL}?${qs}`);
    return late;
  };

  return {
    isLoading,
    data,
    stats,
    getTotalPresent,
    getTotalAbsent,
    getTotalLate,
    mutate,
  };
};

export const useDashboardAttendance = (query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const url = qs ? `${ATTENDANCE_URL}?${qs}` : ATTENDANCE_URL;

  const { data, isLoading, mutate } = useSWR(url, api.get);

  return {
    isLoading,
    data,
    monthlyDatas: data?.monthlyDatas || [],
    weeklyDatas: data?.weeklyDatas || [],
    dailyDatas: data?.dailyDatas || [],
    mutate,
  };
};
